import { render, staticRenderFns } from "./BrandNews.vue?vue&type=template&id=f176afd8&scoped=true"
import script from "./BrandNews.vue?vue&type=script&lang=js"
export * from "./BrandNews.vue?vue&type=script&lang=js"
import style0 from "./BrandNews.vue?vue&type=style&index=0&id=f176afd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f176afd8",
  null
  
)

export default component.exports